export default __webpack_public_path__ + "static/realWorldImg4-88fe30186791fd121a703e14bc94bbf4.webp";